import { render, staticRenderFns } from "./TheRightPanelPartsController.vue?vue&type=template&id=61aca30f&"
import script from "./TheRightPanelPartsController.vue?vue&type=script&lang=ts&"
export * from "./TheRightPanelPartsController.vue?vue&type=script&lang=ts&"
import style0 from "./TheRightPanelPartsController.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports